import React from 'react';

const MonitorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className="feather feather-monitor"
    viewBox="0 0 24 24">
    <title>Figma Desktop</title>
    <rect width="20" height="14" x="2" y="3" rx="2" ry="2"></rect>
    <path d="M8 21h8M12 17v4"></path>
  </svg>
);

export default MonitorIcon;
